import React from 'react';
import PropTypes from 'prop-types';

import { Form, Radio, Icon, Input, Button } from 'semantic-ui-react';

const RegistrationPage = ({
  onClose,
  onSelect,
  error,
  onInputChange,
  redirectToRegister,
  checked,
  sourceType,
}) => {
  return (
    <div>
      <Icon
        onClick={onClose}
        name="sh-e-remove-2"
        css={{
          cursor: 'pointer',
          position: 'absolute',
          top: 30,
          right: 30,
          fontSize: 34,
          color: 'black',
        }}
      />
      <div
        css={{
          color: '#6C2D8A',
          fontSize: 18,
          fontFamily: 'Roboto',
          lineHeight: 1.3,
          fontWeight: 700,
          letterSpacing: 'normal',
          marginBottom: 5,
        }}
      >
        Select your course
      </div>
      <h2
        className="ui header"
        css={{
          '&&&&.ui.header': {
            color: '#333333',
            marginTop: 0,
            marginBottom: 20,
            padding: 0,
          },
        }}
      >
        Where did you hear about TeSA Virtual Fair?
      </h2>
      <Form.Group inline>
        <Form.Field
          css={{ marginBottom: 15 }}
          control={Radio}
          label="TIPP: Tech Immersion and Placement Programme"
          value="TIPP"
          checked={checked === 'TIPP'}
          onChange={onSelect}
        />
        <Form.Field
          css={{ marginBottom: 15 }}
          control={Radio}
          label="SGUS: SGUnited Skills Programme"
          value="SGUS"
          checked={checked === 'SGUS'}
          onChange={onSelect}
        />
        <Form.Field
          css={{ marginBottom: 15 }}
          control={Radio}
          label="SGUT: SGUnited Traineeship Programme"
          value="SGUT"
          checked={checked === 'SGUT'}
          onChange={onSelect}
        />
        <Form.Field
          css={{ marginBottom: 15 }}
          control={Radio}
          label="SGUP-CT: SGUnited Mid-Career Pathways - Company Training"
          value="SGUP-CT"
          checked={checked === 'SGUP-CT'}
          onChange={onSelect}
        />
        <Form.Field
          css={{ marginBottom: 15 }}
          control={Radio}
          label="SGUP-CA: SGUnited Mid-Career Pathways - Company Attachment"
          value="SGUP-CA"
          checked={checked === 'SGUP-CA'}
          onChange={onSelect}
        />
        <Form.Field
          css={{
            marginBottom: 15,
          }}
          control={Radio}
          label="Other"
          value="other"
          checked={checked === 'other'}
          onChange={onSelect}
        />
        {checked === 'other' && (
          <>
            <Input
              css={{
                marginBottom: error ? 5 : 0,
              }}
              maxLength="10"
              placeholder="Type your source here…"
              value={sourceType}
              onChange={onInputChange}
            />
            <p css={{ color: 'red' }}>{error}</p>
          </>
        )}
      </Form.Group>
      <div css={{ display: 'flex', flexDirection: 'column', marginTop: 15 }}>
        <Button
          css={{
            '&:hover': {
              filter: 'brightness(85%)',
            },
            '&&&&.ui.button': {
              color: 'white',
              background: '#6C2D8A',
              width: 'max-content',
            },
          }}
          onClick={redirectToRegister}
        >
          View Jobs
        </Button>
        <p css={{ color: 'grey', fontSize: 12, marginTop: 10 }}>
          By applying to a job at the TeSA Virtual Fair, you agree to receiving
          job proposals from all participating employers.
        </p>
      </div>
    </div>
  );
};

RegistrationPage.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  redirectToRegister: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired,
  sourceType: PropTypes.string.isRequired,
  checked: PropTypes.string.isRequired,
};

export default RegistrationPage;
